export default "__VITE_ASSET__e1eab7de__"